//import { getVisits, setCurrentFilters } from "../../visit/actions";

export const STATS_ADD_FILTER = "stats/ADD_FILTER";
export const STATS_SELECT_LEFT_MENU_ITEM = "stats/SELECT_LEFT_MENU_ITEM";
export const STATS_SELECT_LEFT_MENU_KPI = "stats/SELECT_LEFT_MENU_KPI";
export const STATS_SET_LEFT_MENU_ITEM = "stats/SET_LEFT_MENU_ITEM";
export const STATS_SELECT_LEFT_MENU_SUBITEM = "stats/SET_LEFT_MENU_SUBITEM";
export const STATS_SELECT_DIMENSION = "stats/SELECT_DIMENSION";
export const STATS_SELECT_KPI = "stats/SELECT_KPI";
export const STATS_SELECT_MAIN_FILTER = "stats/SELECT_MAIN_FILTER";
export const STATS_SELECT_VIEW = "stats/SELECT_VIEW";
//SUBFILTER
export const STATS_SUBFILTER_FETCH_DATA = "stats/SUBFILTER_FETCH_DATA";
export const STATS_SUBFILTER_SELECTED = "stats/SUBFILTER_SELECTED";
export const STATS_SUBFILTER_LOADING = "stats/SUBFILTER_LOADING";
export const STATS_SUBFILTER_DATA = "stats/SUBFILTER_DATA";
export const STATS_SUBFILTER_CHANGE = "stats/SUBFILTER_CHANGE";
export const STATS_SUBFILTER_SET_VALUES = "stats/SUBFILTER_SET_VALUES";
//DATA
export const STATS_FETCH_DATA = "stats/FETCH_DATA";
export const STATS_SET_DATA = "stats/SET_DATA";
export const STATS_FETCH_DASHBOARD_DATA = "stats/FETCH_DASHBOARD_DATA";
export const STATS_SET_DASHBOARD_DATA = "stats/SET_DASHBOARD_DATA";
export const STATS_SET_TABLE_DATA = "stats/SET_TABLE_DATA";
export const STATS_SET_SUMMARY_DATA = "stats/SET_SUMMARY_DATA";
export const STATS_GRAPH_LOADING = "stats/GRAPH_LOADING";
export const STATS_TABLE_LOADING = "stats/TABLE_LOADING";
export const STATS_EXPORT_DATA = "stats/EXPORT_DATA";
export const STATS_EXPORT_GAIN_DATA = "stats/EXPORT_GAIN_DATA";
export const STATS_EXPORT_RAW = "stats/EXPORT_RAW";
export const STATS_MAIL_COMMANDE_REASSORT = "stats/MAIL_COMMANDE_REASSORT";
export const STATS_MAIL_SAMPLE_PARODONTAX = "stats/MAIL_SAMPLE_PARODONTAX";
export const STATS_MAIL_NB_VISITS_PER_DAY = "stats/MAIL_NB_VISITS_PER_DAY";
export const STATS_MAIL_NB_VISITS_PER_DAY_LUCCA = "stats/MAIL_NB_VISITS_PER_DAY_LUCCA";
export const STATS_MAIL_ADVIL_GAIN = "stats/MAIL_ADVIL_GAIN";
export const STATS_MAIL_VISIT_RELEVE_PHARMA = "stats/MAIL_VISIT_RELEVE_PHARMA";
//SUMMARY
export const STATS_FETCH_SUMMARY_DATA = "stats/FETCH_SUMMARY_DATA";
export const STATS_CHANGE_SUMMARY_DIMENSIONS = "stats/CHANGE_SUMMARY_DIMENSIONS";
export const STATS_CHANGE_SUMMARY_KPI = "stats/CHANGE_SUMMARY_KPI";
export const STATS_SET_SUMMARY_DIMENSIONS = "stats/SET_SUMMARY_DIMENSIONS";
export const STATS_SET_SUMMARY_KPI = "stats/SET_SUMMARY_KPI";
export const STATS_SWITCH_SUMMARY_DISPLAY_TYPE = "stats/SWITCH_SUMMARY_DISPLAY_TYPE";
export const STATS_SET_SUMMARY_GAIN_CHECKED = "stats/SET_SUMMARY_GAIN_CHECKED";

//PERIOD
export const STATS_PERIOD_CHANGE = "stats/PERIOD_CHANGE";
export const STATS_PERIOD_CHANGE_FROM_SELECT = "stats/PERIOD_CHANGE_FROM_SELECT";
export const STATS_SET_PERIOD = "stats/SET_PERIOD";

//PERIODS
export const STATS_SET_PERIODS_ITEM_SELECTED = "stats/SET_PERIODS_ITEM_SELECTED";
export const STATS_SET_PERIODS = "stats/STATS_SET_PERIODS";
//KPIS
export const STATS_SET_KPIS = "stats/SET_KPIS";
export const STATS_SET_ACTIONS = "stats/SET_ACTIONS";
export const STATS_SET_STATS_FILTERS = "stats/SET_STATS_FILTERS";

export const STATS_INIT = "stats/INIT";
export const STATS_RESET = "stats/RESET";
export const STATS_SET_PERMALINK_DATA = "stats/SET_PERMALINK_DATA";
export const STATS_TOGGLE_IS_DATA_DISPLAYED = "stats/TOGGLE_IS_DATA_DISPLAYED";
/**
 * build action
 * @param type
 * @param payload
 * @return {{type: *}}
 */
function action(type, payload = {}) {
  return { type, ...payload };
}

export const changeLeftMenuItem = leftMenuItem => action(STATS_SELECT_LEFT_MENU_ITEM, { leftMenuItem });
export const changeLeftMenuKpi = (kpiId, init, viewType) =>
  action(STATS_SELECT_LEFT_MENU_KPI, { kpiId, init, viewType });
export const changeLeftMenuSubItem = item => action(STATS_SELECT_LEFT_MENU_SUBITEM, { item });
export const changeDimension = item => action(STATS_SELECT_DIMENSION, { item });
export const setLeftMenuItem = leftMenuItem => action(STATS_SET_LEFT_MENU_ITEM, { leftMenuItem });
export const selectKpi = kpi => action(STATS_SELECT_KPI, { kpi });
export const selectMainFilter = filter => action(STATS_SELECT_MAIN_FILTER, { filter });
export const selectSubFilter = filter => action(STATS_SUBFILTER_SELECTED, { filter });
export const fetchStats = () => action(STATS_FETCH_DATA);
export const fetchData = filter => action(STATS_SUBFILTER_FETCH_DATA, { filter });
export const changeSubfilterValues = (subfilterId, values) => action(STATS_SUBFILTER_CHANGE, { subfilterId, values });
export const setSubfilterValues = (subfilterId, values) => action(STATS_SUBFILTER_SET_VALUES, { subfilterId, values });
export const changePeriodFromSelect = (values, periodDesignation) =>
  action(STATS_PERIOD_CHANGE_FROM_SELECT, { values, periodDesignation });
export const changePeriod = values => action(STATS_PERIOD_CHANGE, { values });
export const setGraphLoading = graphLoading => action(STATS_GRAPH_LOADING, { graphLoading });
export const setTableLoading = loading => action(STATS_TABLE_LOADING, { loading });
export const init = queryData => action(STATS_INIT, queryData);
export const setPeriodsItemSelected = item => action(STATS_SET_PERIODS_ITEM_SELECTED, { item });
export const setView = view => action(STATS_SELECT_VIEW, { view });
export const exportData = () => action(STATS_EXPORT_DATA);
export const exportGainData = () => action(STATS_EXPORT_GAIN_DATA);
export const exportRaw = () => action(STATS_EXPORT_RAW);
export const mailCommandeReassort = period => action(STATS_MAIL_COMMANDE_REASSORT, { period });
export const mailSampleParodontax = () => action(STATS_MAIL_SAMPLE_PARODONTAX);
export const mailGainAdvil = period => action(STATS_MAIL_ADVIL_GAIN, { period });
export const mailVisitRelevePharma = period => action(STATS_MAIL_VISIT_RELEVE_PHARMA, { period });
export const mailNbVisitsPerDay = period => action(STATS_MAIL_NB_VISITS_PER_DAY, { period });
export const mailNbVisitsPerDayLucca = period => action(STATS_MAIL_NB_VISITS_PER_DAY_LUCCA, { period });

export const changeSummaryDimensions = data => action(STATS_CHANGE_SUMMARY_DIMENSIONS, { data });
export const setSummaryDimensions = data => action(STATS_SET_SUMMARY_DIMENSIONS, { data });
export const changeSummaryKpi = kpi => action(STATS_CHANGE_SUMMARY_KPI, { kpi });
export const setSummaryKpi = kpi => action(STATS_SET_SUMMARY_KPI, { kpi });
export const fetchSummaryData = () => action(STATS_FETCH_SUMMARY_DATA);
export const switchSummaryDisplayType = () => action(STATS_SWITCH_SUMMARY_DISPLAY_TYPE);
export const setGainChecked = checked => action(STATS_SET_SUMMARY_GAIN_CHECKED, { checked });
export const injectPermalinkData = data => action(STATS_SET_PERMALINK_DATA, { data });
export const onToggleDataDisplayed = () => action(STATS_TOGGLE_IS_DATA_DISPLAYED);



// WEBPACK FOOTER //
// src/modules/stats/actions/stats.js